export const environment = {
  sessionkey: "promentis-sesion-dev",
  apiBaseUrl: "https://psycho.blackforestbytes.com/api/v1",
};
